function sanitizePagePath(location) {
  const pathname = location?.pathname || '/';
  const params = new URLSearchParams(location?.search || '');
  params.delete('t');
  const search = params.toString();
  return `${pathname}${search ? `?${search}` : ''}${location?.hash || ''}`;
}

module.exports = {
  sanitizePagePath,
};
